/**
 * FES product card behavior — size validation + self-contained AJAX add-to-cart.
 * Uses event delegation on document, so it works for cards present at page load
 * AND cards injected later (e.g. Dawn's AJAX facet filtering/sorting/pagination
 * re-rendering the collection grid without a full page reload).
 */
(function () {
  if (window.__fesProductCardInit) return;
  window.__fesProductCardInit = true;

  function openSizeSelector(select) {
    select.classList.add('fes-pc__size-select--invalid');
    if (typeof select.showPicker === 'function') {
      try {
        select.showPicker();
        return;
      } catch (e) {
        /* fall through to focus fallback below */
      }
    }
    select.focus();
    select.reportValidity();
  }

  function updateCartBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const bubbleCount = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
        if (bubbleCount) bubbleCount.textContent = cart.item_count;
      })
      .catch(() => {});
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.fes-pc__size-select');
    if (!select) return;
    const form = select.closest('.fes-pc__form');
    if (!form) return;
    const variantInput = form.querySelector('.fes-pc__variant-id');
    if (variantInput) variantInput.value = select.value;
    select.classList.remove('fes-pc__size-select--invalid');
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.fes-pc__form');
    if (!form) return;
    event.preventDefault();

    const select = form.querySelector('.fes-pc__size-select');
    const addToCartButton = form.querySelector('.fes-pc__add-to-cart');
    const labelEl = addToCartButton ? addToCartButton.querySelector('.fes-pc__add-to-cart-label') : null;
    const spinnerEl = form.querySelector('.loading__spinner');
    const errorEl = form.querySelector('.fes-pc__form-error');

    if (!addToCartButton || addToCartButton.getAttribute('aria-disabled') === 'true') return;

    if (select && select.value === '') {
      openSizeSelector(select);
      return;
    }

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    addToCartButton.setAttribute('aria-disabled', 'true');
    addToCartButton.classList.add('loading');
    if (spinnerEl) spinnerEl.classList.remove('hidden');

    // If a cart drawer is present, request its sections in the same add-to-cart
    // call (matching Dawn's own product-form.js) so we can hand the response to
    // cartDrawer.renderContents() — refreshing its content AND opening it.
    // Otherwise (cart_type = page/notification) just add the item and update the
    // bubble count, same as before.
    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData(form);
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      // Shopify expects a single 'sections' field containing a comma-joined list,
      // not repeated fields — FormData.append stringifies an array via Array#toString
      // (comma-joined), matching exactly what Dawn's own product-form.js sends.
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    fetch(form.action + '.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          throw new Error(data.description || data.message || 'This item could not be added to your cart.');
        }
        // Fire the same pub/sub event Dawn's own product-form.js fires on a
        // successful add — other sections (like the announcement bar's free
        // shipping progress swap) listen for this to know the cart changed.
        // Without it, they'd only pick up the change on a page reload.
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'fes-product-card',
              productVariantId: formData.get('id'),
              cartData: data,
            });
          }
        } catch (e) {
          /* pub/sub bus unavailable */
        }

        if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else {
          updateCartBubble();
        }
        if (labelEl) {
          const originalHtml = labelEl.innerHTML;
          labelEl.textContent = 'Added';
          window.setTimeout(() => {
            labelEl.innerHTML = originalHtml;
          }, 1800);
        }
      })
      .catch((error) => {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = error.message;
        }
      })
      .finally(() => {
        addToCartButton.removeAttribute('aria-disabled');
        addToCartButton.classList.remove('loading');
        if (spinnerEl) spinnerEl.classList.add('hidden');
      });
  });
})();
